import React from 'react';

import './Spinner.css';

export const Spinner = ({ loadingText }) => {
  if (!loadingText) return null;

  return (
    <div className="spinner-container">
      <div className="lds-ring">
        <div />
        <div />
        <div />
        <div />
      </div>
      <p className="spinner-text">{loadingText}</p>
    </div>
  );
};
